import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLoading = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M2.8471 10C2.37926 10 1.99536 10.3803 2.0448 10.8455C2.1812 12.1288 2.62662 13.3646 3.34824 14.4446C4.22729 15.7602 5.47672 16.7855 6.93853 17.391C8.40034 17.9965 10.0089 18.155 11.5607 17.8463C13.1126 17.5376 14.538 16.7757 15.6569 15.6569C16.7757 14.538 17.5376 13.1126 17.8463 11.5607C18.155 10.0089 17.9965 8.40034 17.391 6.93853C16.7855 5.47672 15.7602 4.22729 14.4446 3.34824C13.3646 2.62662 12.1288 2.1812 10.8455 2.0448C10.3803 1.99536 10 2.37926 10 2.8471C10 3.31494 10.3809 3.68834 10.8446 3.751C11.7922 3.87908 12.7021 4.22157 13.5033 4.75691C14.5403 5.44981 15.3485 6.43464 15.8258 7.58687C16.3031 8.73911 16.428 10.007 16.1846 11.2302C15.9413 12.4534 15.3408 13.577 14.4589 14.4589C13.577 15.3408 12.4534 15.9413 11.2302 16.1846C10.007 16.428 8.73911 16.3031 7.58687 15.8258C6.43464 15.3485 5.4498 14.5403 4.75691 13.5033C4.22157 12.7021 3.87908 11.7922 3.751 10.8446C3.68834 10.3809 3.31494 10 2.8471 10Z"
	})
});
const ForwardRef = forwardRef(SvgLoading);
export default ForwardRef;
